(function ($) {

    $(function () {
        const hasV4 = !!document.querySelector('.animate__animated'); // detect Animate.css v4 presence
        const addAnim = (el) => {
            if (hasV4) {
                el.classList.add('animate__animated', 'animate__fadeIn');
            } else {
                el.classList.add('animated', 'fadeIn');
            }
        };
        const ensureVisible = ($els) => {
            $els.each(function () {
                // If WOW left it hidden, force it visible
                const cs = window.getComputedStyle(this);
                if (cs.visibility !== 'visible' || cs.opacity === '0') {
                    this.style.visibility = 'visible';
                    // opportunistically add animation classes if none present
                    if (!this.className.match(/\banimate/)) addAnim(this);
                }
            });
        };

        const showContent = function (show, hide) {
            $(hide).hide();
            $(show).show(); // removed delay to avoid "blank" feel
        };

        var heroClass = ['hero-burgers', 'hero-cleaning', 'hero-croissant', 'hero-gym', 'hero-laptop'];
        $('#hero').each(function () {
            $(this).addClass(heroClass[~~(Math.random() * heroClass.length)]);
        });

        var heroClass = ['hero-uk-cafe', 'hero-uk-garage', 'hero-uk-retail', 'hero-uk-bakery', 'hero-uk-wfh', 'hero-uk-food'];
        $('#hero-uk').each(function () {
            $(this).addClass(heroClass[~~(Math.random() * heroClass.length)]);
        });

        $("#desktop").off('click.vmc').on('click.vmc', 'a', function (evt) {
            evt.preventDefault();
            evt.stopPropagation();

            const $toggle = $(this);
            const $all = $("#all-categories");
            const isVisible = $all.is(':visible');

            $toggle.find('#vmc-label').text(isVisible ? 'View More' : 'View Less');
            $toggle.find('.material-symbols-rounded')
                .text(isVisible ? 'keyboard_arrow_down' : 'keyboard_arrow_up');

            $all.toggle();

            $toggle.toggleClass('active', !isVisible)
                .attr('aria-expanded', String(!isVisible));

            if (window.wow && typeof wow.sync === 'function') wow.sync();
            ensureVisible($('.pop-cat.wow'));
        });

        $('.team-tiles .interview').hide();

        $(document).off('click.tileToggle').on('click.tileToggle', '.team-iles .tile-details-toggle, .team-tiles .tile-details-toggle', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();

            const $tile = $(this).closest('.team-tile');
            if (!$tile.length) return;

            const $details = $tile.find('.tile-details').first();
            const $interview = $details.find('.interview').first();

            $('.team-tiles .tile-details').not($details).removeClass('active');
            $('.team-tiles .interview').not($interview).stop(true, true).fadeOut('fast');

            $details.toggleClass('active');

            const isDesktop = window.matchMedia('(min-width: 749px)').matches;
            if (isDesktop) {
                if ($interview.is(':visible')) {
                    $interview.stop(true, true).fadeOut('fast');
                } else {
                    setTimeout(() => {
                        $interview.stop(true, true).fadeIn('fast');
                    }, 500);
                }
            }
        });

        $(document).off('pointerdown.tileOutside').on('pointerdown.tileOutside', function (e) {
            if ($(e.target).closest('.team-tile').length) return;
            $('.team-tiles .tile-details').removeClass('active');
            $('.team-iles .interview, .team-tiles .interview').stop(true, true).fadeOut('fast');
        });

        $(document).off('keydown.tileKeys').on('keydown.tileKeys', '.team-tiles .tile-details-toggle', function (e) {
            if (e.key === 'Enter' || e.key === ' ' || e.code === 'Space') {
                e.preventDefault();
                $(this).trigger('click');
            }
        });
        $(document).off('keydown.tileEsc').on('keydown.tileEsc', function (e) {
            if (e.key === 'Escape' || e.code === 'Escape') {
                $('.team-tiles .tile-details').removeClass('active');
                $('.team-tiles .interview').stop(true, true).fadeOut('fast');
            }
        });

        $('.tab-link').off('click.tabs').on("click.tabs", function () {
            var tab_id = $(this).attr('data-tab');
            $('.tab-link').removeClass('current');
            $('.tab-content').removeClass('current');
            $(this).addClass('current');
            $("#" + tab_id).addClass('current');
        });

        // =============================
        // YouTube carousel (merged)
        // =============================
        (function setupYouTubeCarousel() {
            var $el = $(".youtube-carousel");
            if (!$el.length) return;

            // avoid double-binding of handlers
            if (!$el.data('ytc-init')) {
                $el.owlCarousel({
                    items: 3,
                    dots: true,
                    lazyLoad: false,
                    smartSpeed: 800,
                    nav: false,
                    responsiveRefreshRate: 50,
                    responsive: {
                        0: { items: 1 },
                        700: { items: 2 },
                        1200: { items: 3 }
                    }
                });
                $el.data('ytc-init', true);

                // ensure recalculation after images load & after breakpoint jumps
                $el.find('img').on('load.ytc', function () {
                    $el.trigger('refresh.owl.carousel');
                });

                // debounce refresh on resize
                var t;
                $(window).on('resize.ytc', function () {
                    clearTimeout(t);
                    t = setTimeout(function () {
                        if ($el.hasClass('owl-loaded')) {
                            $el.trigger('refresh.owl.carousel');
                        }
                    }, 120);
                });
            }
        })();

        // =============================
        // State manager (kept, but no longer destroys YouTube carousel on width change)
        // =============================
        ssm.addState({
            id: 'hot-franchises-medium',
            maxWidth: 750,
            onEnter: function () {
                var $el = $(".hot-franchises-tiles");
                if (!$el.length || $el.hasClass('owl-loaded')) return;
                $el.owlCarousel({
                    items: 2,
                    dots: true,
                    lazyLoad: true,
                    slideSpeed: 800,
                    nav: false,
                    responsive: {
                        0: { items: 1 },
                        460: { items: 2 },
                        750: { items: 3 }
                    }
                });
            },
            onLeave: function () {
                var $el = $(".hot-franchises-tiles");
                if ($el.hasClass('owl-loaded')) {
                    $el.trigger('destroy.owl.carousel');
                }
            }
        });

        // IMPORTANT: we keep the state to ensure WOW/other bits run consistently,
        // but the carousel itself is now initialised globally above and persists across sizes.
        ssm.addState({
            id: 'youtube-medium',
            maxWidth: 1000,
            onEnter: function () {
                var $el = $(".youtube-carousel");
                if (!$el.length) return;
                if (!$el.hasClass('owl-loaded')) {
                    // If something destroyed it before, re-init with our unified settings
                    $el.owlCarousel({
                        items: 3,
                        dots: true,
                        lazyLoad: false,
                        smartSpeed: 800,
                        nav: false,
                        responsiveRefreshRate: 50,
                        responsive: {
                            0: { items: 1 },
                            700: { items: 2 },
                            1200: { items: 3 }
                        }
                    }).data('ytc-init', true);
                } else {
                    $el.trigger('refresh.owl.carousel');
                }
            },
            onLeave: function () {
                // Do NOT destroy anymore; let it persist and just refresh
                var $el = $(".youtube-carousel");
                if ($el.hasClass('owl-loaded')) {
                    $el.trigger('refresh.owl.carousel');
                }
            }
        });

        ssm.addState({
            id: 'advice-small',
            maxWidth: 650,
            onEnter: function () {
                var $el = $(".advice-article-owl");
                if (!$el.length || $el.hasClass('owl-loaded')) return;
                $el.owlCarousel({
                    autoWidth: true,
                    autoHeight: true
                });
            },
            onLeave: function () {
                var $el = $(".advice-article-owl");
                if ($el.hasClass('owl-loaded')) {
                    $el.trigger('destroy.owl.carousel');
                }
            }
        });

        if (typeof ssm !== 'undefined' && ssm.ready) ssm.ready();

        if (typeof WOW !== 'undefined') {
            if (!window.wow) {
                window.wow = new WOW({
                    boxClass: 'wow',
                    animateClass: hasV4 ? 'animate__animated' : 'animated',
                    live: false,
                    resetAnimation: false
                });
                wow.init();
            }

            (function () {
                let t;
                $(window).off('scroll.wowSync').on('scroll.wowSync', function () {
                    clearTimeout(t);
                    t = setTimeout(function () {
                        if (wow && typeof wow.sync === 'function') wow.sync();
                        ensureVisible($('.pop-cat.wow')); // belt-and-braces
                    }, 120);
                });
                window.addEventListener('pageshow', function () {
                    if (wow && typeof wow.sync === 'function') wow.sync();
                    ensureVisible($('.pop-cat.wow'));
                });
            })();
        }

        (function () {
            const tiles = document.querySelectorAll('.pop-cat.wow');
            if (!tiles.length) return;

            if ('IntersectionObserver' in window) {
                const io = new IntersectionObserver((entries) => {
                    entries.forEach((e) => {
                        if (!e.isIntersecting) return;
                        // force visible + add animation classes if missing
                        e.target.style.visibility = 'visible';
                        if (!e.target.className.match(/\banimate/)) addAnim(e.target);
                        io.unobserve(e.target);
                    });
                }, { root: null, threshold: 0.01 });
                tiles.forEach(el => io.observe(el));
            } else {
                ensureVisible($('.pop-cat.wow'));
            }
        })();

        ensureVisible($('.pop-cat.wow'));
    });

})(jQuery);